import MuiInputBase, { type InputBaseProps } from "@mui/material/InputBase";

export type { InputBaseProps };

export function InputBase(props: InputBaseProps) {
  return <MuiInputBase {...props} />;
}
